<template>
    <el-config-provider :locale="elLanguage">
        <router-view v-if="isRouterAlive"></router-view>
    </el-config-provider>
</template>

<script>
import { ElConfigProvider } from 'element-plus'
import zhCn from 'element-plus/es/locale/lang/zh-cn'
import en from 'element-plus/es/locale/lang/en'
export default {
    name: 'App',
    provide() {
        return {
            reload: this.reload,
        }
    },
    data() {
        return {
            isRouterAlive: true,
        }
    },
    components: {
        ElConfigProvider
    },
    computed: {
        elLanguage () {
            return this.$i18n.locale =='en'? en : zhCn
        }
    },
    methods: {
        reload() {
            console.log('reload')
            this.isRouterAlive = false
            this.$nextTick(function () {
                this.isRouterAlive = true
            })
        }
    },
    watch: {
        '$i18n.locale'(newVal, oldVal) {
            if (newVal !== oldVal) {
                // this.$router.go(0)
                this.reload();
            }
        }
    }
};
</script>

<style>
.text-danger1 {
    color: red !important;
}
</style>
